<template>
    <DCard
        padding
    >
        <Form
            :errors="errors"
            :idn-character-set="idnCharacterSet"
            @form-submitted="submitForm"
        />
    </DCard>
</template>

<script setup>
import { route } from '~@/Composables/route'
import Form from '~@/Components/Settings/IdnCharacterSets/Form.vue'

const props = defineProps({
    idnCharacterSet: {
        type: Object,
        default: () => {
            return {}
        }
    },
    errors: {
        type: Object,
        default: () => {
            return {}
        }
    }
})

function submitForm (form) {
    form.put(route('settings.idn-character-sets.update', { idn_character_set: props.idnCharacterSet.id }))
}
</script>
